import { getSelectors, RouterReducerState } from "@ngrx/router-store";
import { createFeatureSelector, createSelector } from "@ngrx/store";
import {
  ROOM_LIVE_VIEW_AUTOPLAY_POLICY_ENABLED_DEFAULT,
  ROOM_LIVE_VIEW_AUTOPLAY_POLICY_ENABLED_QUERY_PARAM_NAME
} from "@youm-front/room/domain";

const selectRouter = createFeatureSelector<RouterReducerState>("router");
const { selectQueryParam } = getSelectors(selectRouter);

export const autoplayPolicyEnabled = createSelector(
  selectQueryParam(ROOM_LIVE_VIEW_AUTOPLAY_POLICY_ENABLED_QUERY_PARAM_NAME),
  (_) => {
    return _ ? !!Number(_) : ROOM_LIVE_VIEW_AUTOPLAY_POLICY_ENABLED_DEFAULT;
  }
);
export const autoplayPolicyDisabled = createSelector(
  autoplayPolicyEnabled,
  (_) => !_
);
